var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IconButton btn",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"label"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"icon"},[_c('Icon',{attrs:{"name":_vm.icon}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }